import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PATH_DASHBOARD } from '../../../routes/paths';
import { checkModules, checkWorkspace } from 'guards/CheckRoles';
import { RootState, useSelector } from '../../../redux/store';
import { getDeviceMeasures } from 'api';
import dayjs from 'dayjs';
import { Device, Measure } from '../../../@types/model/device';

function DeviceDetailsStateOCR(props: any) {
  const { refactoredDevice, device } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { workspace } = useSelector((state: RootState) => state.workspace);
  const [weeklyAverageConsum, setWeeklyAverageConsum] = useState<number>(0);
  const [dailyAverageConsum, setDailyAverageConsum] = useState<number>(0);

  useEffect(() => {
    getDeviceMeasures(
      device.guid,
      dayjs().subtract(1, 'year').hour(0).minute(0).second(0),
      dayjs().hour(23).minute(59).second(59),
      (device: Device, measures: Measure[], availableMetrics: string[]) => {
        let volumes: number[] = [];
        measures.forEach((measure, index) => {
          measure.attributes.data.forEach((dat) => {
            if (dat.name === 'Value') {
              // Before adding a measure, we have to check if there are more than one day of difference.
              if (index !== 0 && index !== volumes.length - 1) {
                if (
                  Math.abs(
                    dayjs(measure.attributes.date).diff(measures[index - 1].attributes.date, 'hour')
                  ) > 40
                ) {
                  let number_days_difference = Math.ceil(
                    Math.abs(
                      dayjs(measure.attributes.date).diff(
                        measures[index - 1].attributes.date,
                        'hour'
                      )
                    ) / 24
                  );
                  let difference = Math.abs(parseFloat(dat.value)) - volumes[volumes.length - 1];
                  let previousValue = volumes[volumes.length - 1];
                  for (let days = 0; days < number_days_difference - 1; days++) {
                    let valueNew = previousValue + difference / number_days_difference;
                    volumes.push(valueNew);
                  }
                }
              }
              volumes.push(Math.abs(parseFloat(dat.value)));
            }
          });
        });
        let differences: number[] = volumes.map((volume: number, index: number) => {
          if (index !== 0 && index !== volumes.length - 1) {
            return Math.abs(volume - volumes[index - 1]) as number;
          }
          return 0;
        });
        let daily_average_consum =
          differences.reduce((partialSum, a) => partialSum + a, 0) / differences.length;

        let weekly_average_consum = daily_average_consum * 7;

        setDailyAverageConsum(daily_average_consum);
        setWeeklyAverageConsum(weekly_average_consum);
      }
    );
  }, []);

  return (
    <div className="cuadro-redondeado" style={{ marginBottom: 20, marginRight: 0 }}>
      <h3>{t('ocr_counter_state')}</h3>
      <div className="groups">
        <div className="group" style={{ marginRight: 0 }}>
          <div className="estados">
            <div className="col">
              <label>{t('daily_average_consum')}</label>
              <div className="valor">
                {Intl.NumberFormat().format(dailyAverageConsum) + ` ${refactoredDevice?.unit}`}
              </div>
            </div>
            <div className="col">
              <label>{t('weekly_average_consum')}</label>
              <div className="valor">
                {Intl.NumberFormat().format(weeklyAverageConsum) + ` ${refactoredDevice?.unit}`}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeviceDetailsStateOCR;
